<template>
  <div>
    <div class="d-flex align-items-center justify-content-between g-4 mb-4">
      <h2 class="mb-0">
        <i class="fa-duotone fa-home text-primary fa-fw"></i> {{ translate("home") }}
      </h2>
      <ButtonView v-if="authorization.permission('community.homePage.edit')" type="normal" color="primary" @click="editing = true">
        <div class="d-flex align-items-center g-2">
          <i class="fas fa-edit"></i>
          {{ translate("edit") }}
        </div>
      </ButtonView>
    </div>
    <HttpContentView :endpoint="utilities.path('communities/@/home-page', communityId)" v-model:reload="reload">
      <template v-slot:content="{ data }">
        <RichTextView :content="data.content" :features="contentFeatures"/>
        <ModalView :active="editing" size="xlarge">
          <template v-slot:header>
            <div class="d-flex align-items-center justify-content-between g-4">
              <h3 class="mb-0">{{ translate("community.homePage") }}</h3>
              <ModalCloseButtonView @click="editing = false"/>
            </div>
          </template>
          <template v-slot:body>
            <HttpFormView :endpoint="utilities.path('communities/@/home-page', communityId)" method="put" :content="data" @success="editing = false; reload = true">
              <template v-slot:form="{ content, errors, submit, loading }">
                <RichTextInputView v-model:value="content.content" :features="contentFeatures" :errors="errors.content ? Array.isArray(errors.content) ? errors.content : [translate('richText.format.invalid')] : undefined"/>
                <div class="d-flex align-items-center g-4 mt-4">
                  <ButtonView type="normal" color="primary" class="w-100" @click="submit">
                    {{ translate("save") }}
                  </ButtonView>
                  <ButtonView type="normal" color="secondary" class="w-100" @click="editing = false">
                    {{ translate("cancel") }}
                  </ButtonView>
                </div>
                <SpinnerView color="primary" :active="loading"/>
              </template>
            </HttpFormView>
          </template>
        </ModalView>
      </template>
    </HttpContentView>
  </div>
</template>

<script setup>
import {
  richTextFeatures,
  HttpContentView,
  utilities,
  ModalView,
  ButtonView,
  HttpFormView,
  SpinnerView,
  RichTextView,
  RichTextInputView,
  ModalCloseButtonView
} from "@niftybit/vue";
import {ref} from "vue";
import authorization from "@/authorization";

const props = defineProps({
  communityId: String
});

const reload = ref(false);
const editing = ref(false);

const contentFeatures = [
  richTextFeatures.paragraph.create(),
  richTextFeatures.text.create(),
  richTextFeatures.hardBreak.create(),
  richTextFeatures.heading.create(),
  richTextFeatures.textStyle.create(),
  richTextFeatures.codeBlock.create(),
  richTextFeatures.bulletList.create(),
  richTextFeatures.orderedList.create(),
  richTextFeatures.infoBox.create(),
  richTextFeatures.blockQuote.create(),
  richTextFeatures.textAlign.create(),
  richTextFeatures.code.create(),
  richTextFeatures.strikethrough.create(),
  richTextFeatures.bold.create(),
  richTextFeatures.underline.create(),
  richTextFeatures.italic.create(),
  richTextFeatures.link.create(),
  richTextFeatures.videoEmbed.create(),
  richTextFeatures.image.create().uploads(utilities.path("communities/@/home-page/images", props.communityId), "post", ["png", "jpg"])
];

</script>